import React, {useState} from "react";
import {BsWhatsapp} from "react-icons/bs";

const FloatingWhatsApp = () => {
    const [expanded, setExpanded] = useState(false);

    return (
        <a
            href="https://wa.me/919043635749?text=Hi%20Pivot%20TechX!%20I%20have%20an%20enquiry."
            target="_blank"
            rel="noreferrer"
            aria-label="Chat with us on WhatsApp"
            onMouseEnter={() => setExpanded(true)}
            onMouseLeave={() => setExpanded(false)}
            style={{
                position: "fixed",
                bottom: "24px",
                right: "24px",
                zIndex: 9999,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "52px",
                padding: expanded ? "0 20px" : "0 0",
                width: expanded ? "auto" : "52px",
                borderRadius: expanded ? "14px" : "14px",
                background: "linear-gradient(135deg, #0a0c3e, #320545)",
                color: "#fff",
                boxShadow: "0 8px 22px rgba(50,5,69,0.45)",
                textDecoration: "none",
                transition: "all 0.3s ease",
                gap: expanded ? "10px" : "0",
                overflow: "hidden",
            }}
        >
            <BsWhatsapp size={26} style={{flexShrink: 0}}/>
            <span
                style={{
                    fontSize: "1rem",
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                    maxWidth: expanded ? "140px" : "0",
                    opacity: expanded ? 1 : 0,
                    transition: "max-width 0.3s ease, opacity 0.3s ease",
                }}
            >
                Chat with us
            </span>
        </a>
    );
};

export default FloatingWhatsApp;
